import React from "react";
import {
  Card,
  CardContent,
  Table,
  Box,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
  Stack,
} from "@mui/material";
import dayjs from "dayjs";
import NoData from "components/NoData";
import { I18n } from "@aws-amplify/core";
import useMediaQuery from "@mui/material/useMediaQuery";

const CaseDetailsCard = ({ data }) => {
  const isMobileDevice = useMediaQuery("(max-width:600px)");
  const formatTimestamp = (timestamp) => dayjs(timestamp).format("YYYY-MM-DD HH:mm:ss");

  const headerCells = [
    {
      id: "case_number",
      label: I18n.get("Case Number"),
      renderCell: (params) => (
        <Typography
          component="a"
          href={process.env.REACT_APP_ENV_ENVIRONMENT != 'prod' ? `https://eptarefrigeration--bugfix.sandbox.lightning.force.com/${params.row.case_id}` : `https://eptarefrigeration.lightning.force.com/${params.row.case_id}`}
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            fontSize: "medium",
            cursor: "pointer",
            textDecoration: "underline",
          }}
        >
          {params.value}
        </Typography>
      ),
    },
    {
      id: "creation_date",
      label: I18n.get("Creation Date"),
      renderCell: (params) => (
        <Typography variant="body2">{formatTimestamp(params.value)}</Typography>
      ),
    },
    { id: "creation_agent", label: I18n.get("Creation Agent") },
    { id: "case_id", label: I18n.get("Case ID") },
  ];

  if (!data || Object.keys(data).length === 0) {
    return (
      <Card>
        <CardContent sx={{ padding: "1rem", "&:last-child":{padding:"1rem"} }}>
          <Stack
            spacing={2}
            direction="row"
            alignItems="center"
            justifyContent="flex-end"
            sx={{ pb: 2 }}
          >
            <Typography variant="h5">{I18n.get("Case Details")}</Typography>
          </Stack>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <NoData />
          </Box>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
       <CardContent sx={{ padding: "1rem", "&:last-child":{padding:"1rem"} }}>
        <Stack
          spacing={2}
          direction="row"
          alignItems="center"
          justifyContent="flex-end"
          sx={{ pb: 2 }}
        >
          <Typography variant="h5">{I18n.get("Case Details")}</Typography>
        </Stack>
        <TableContainer>
          <Table>
            <TableBody>
              {headerCells.map((column, colIndex) => (
                <React.Fragment key={colIndex}>
                  <TableCell
                    style={{
                      whiteSpace: "normal",
                      wordWrap: "break-word",
                      padding: "8px",
                      borderBottom: "1px solid #e0e0e0",
                      fontSize: "14px",
                      lineHeight: 1.6,
                    }}
                  >
                    <Typography
                      variant="body2"
                      sx={{
                        fontWeight: "bold",
                        fontSize: "15px",
                      }}
                    >
                      {column.label}:
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        fontSize: "14px",
                      }}
                    >
                      {column.renderCell
                        ? column.renderCell({
                            value: data[column.id],
                            row: data,
                          })
                        : column.id.includes("date") && data[column.id]
                        ? formatTimestamp(data[column.id])
                        : data[column.id] !== undefined &&
                          data[column.id] !== null &&
                          data[column.id] !== "N/A"
                        ? data[column.id]
                        : ""}
                    </Typography>
                  </TableCell>
                  {(colIndex + 1) % (isMobileDevice ? 1 : 2) === 0 && (
                    <TableRow key={`spacer-${colIndex}`}></TableRow>
                  )}
                </React.Fragment>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  );
};

export default CaseDetailsCard;
